module.exports = "<div class=\"example\">\n    <img src=\"<%-exampleImg%>\">\n</div>\n<form class=\"form-horizontal\">\n    <div class=\"form-group col-sm-12\">\n        <label class=\"col-xs-12\">Enter Text Here:</label>\n        <div class=\"col-xs-12\">\n            <textarea class=\"form-control add-text\" style=\"height: 200px;\" placeholder=\"Enter Text Here\"><%- widget.getParamValue('TEXT_WIDGET_TEXT', '') %></textarea>\n        </div>\n    </div>\n</form>";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/modals/reports/modify_widgets/textwidget/textwidget.html
// module id = 810
// module chunks = 7